import React from 'react';
import { Surface } from '@packages/ui/layout';
import type { FormSurfaceNode } from '../../types/layout';
import { FormNodeRenderer } from '../FormNodeRenderer';

interface SurfaceRendererProps {
  node: FormSurfaceNode;
  namePrefix?: string;
}

const FLUSH_STYLE: React.CSSProperties = { border: 'none', borderRadius: 0 };

export const FormSurfaceRenderer = React.memo(function FormSurfaceRenderer({ node, namePrefix }: SurfaceRendererProps): React.ReactElement {
  return (
    <Surface
      variant={node.variant ?? 'default'}
      tone={node.tone ?? 'neutral'}
      bordered={node.bordered}
      padding={node.padding}
      semanticId={node.semanticId}
      style={node.flush === true ? FLUSH_STYLE : undefined}
    >
      {node.children.map((child, idx) => (
        <FormNodeRenderer key={idx} node={child} namePrefix={namePrefix} />
      ))}
    </Surface>
  );
});
